module.exports = __webpack_public_path__ + "static/media/align-slash.0a65650b.svg";